import { createContext, useContext, useMemo, useState } from 'react';
import { useTrip } from './tripContext.jsx';

// Phase 1 stub: defaults to Kishan (id "kris"). Real auth (briefing token → session cookie)
// arrives in Phase 5; the player-switcher inside test mode arrives in Phase 7.
const STORAGE_KEY = 'somesay_active_player';

const UserContext = createContext(null);

export function UserProvider({ children }) {
  const { trip } = useTrip();
  const [activePlayerId, setActivePlayerId] = useState(() => {
    if (typeof window === 'undefined') return 'kris';
    return window.localStorage.getItem(STORAGE_KEY) || 'kris';
  });

  const value = useMemo(() => {
    const player = trip?.players?.find((p) => p.id === activePlayerId) || null;
    return {
      activePlayerId,
      player,
      setActivePlayer: (id) => {
        setActivePlayerId(id);
        if (typeof window !== 'undefined') {
          window.localStorage.setItem(STORAGE_KEY, id);
        }
      },
    };
  }, [trip, activePlayerId]);

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

export function useUser() {
  const ctx = useContext(UserContext);
  if (!ctx) throw new Error('useUser must be used inside <UserProvider>');
  return ctx;
}
